import axios from 'axios';

function getSettings() {
	const url = `/admin/settings`;
	return axios
		.get(url)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

function updateSettings(data) {
	const url = `/admin/settings`;
	return axios
		.post(url, data)
		.then((x) => x.data)
		.then((x) => {
			if (x.status == 'error') {
				return Promise.reject(x);
			}
			return x;
		});
}

export { getSettings, updateSettings };
